"use strict";

var storeSelectorModal = require("./modal/storeSelectorModal");

$("#storeSelectorModal").on("shown.bs.modal", function () {
    $(this).siblings().attr("aria-hidden", "true");
    $(".checkout-btn").trigger("focus");
});

$("#storeSelectorModal").on("hidden.bs.modal", function () {
    $(this).siblings().attr("aria-hidden", "false");
});


// --- Estado del módulo (closure) ---
var searchTimeout = null; // debounce del input de búsqueda del modal
var selectedValue = null; // ID de sucursal tildada en el modal (aún sin confirmar)
var currentPid = null; // SKU/variante activo del PDP
var $lastFocusedTrigger = null; // elemento que abrió el modal; fallback de foco al cerrar
var isStoreConfirmed = false; // true solo tras un confirmSelection() exitoso; se usa
// para revertir el radio "Retirar por sucursal" si el modal se cierra sin
// confirmar (el click nativo del navegador lo marca igual, aunque no se
// haya elegido ninguna sucursal todavía)

/**
 * Habilita/deshabilita [data-js-reset] según si hay algo que resetear:
 * texto tipeado en el buscador, o una sucursal marcada en el modal.
 * @returns {void}
 */
function updateResetButtonState() {
    var hasSearchTerm = $("#deliverySelectorSearch").val().trim() !== "";
    var hasSelection = !!selectedValue;

    $("[data-js-reset]").prop("disabled", !hasSearchTerm && !hasSelection);
}

/**
 * Marca el radio del método vigente en sesión (data-delivery-method), pero
 * SOLO si ese radio está habilitado. Un método no disponible (radio
 * deshabilitado) nunca queda marcado.
 * @param {jQuery} $selector - [data-js-delivery-method-selector]
 * @returns {void}
 */
function checkSessionMethodIfAvailable($selector) {
    var currentMethod = $selector.attr("data-delivery-method");

    $selector.find('input[name="deliveryMethod"]').prop("checked", false);

    if (currentMethod) {
        $selector
            .find(
                'input[name="deliveryMethod"][value="' +
                    currentMethod +
                    '"]:not(:disabled)',
            )
            .prop("checked", true);
    }
}

/**
 * Actualiza (o crea) el bloque de sucursal seleccionada en el PDP tras confirmar.
 * store-icon, store-name y change-store son hijos directos de .delivery-method__card
 * (sin wrapper), posicionados por CSS Grid — ver delivery-method.scss.
 * Si el bloque ya existía ("Cambiar sucursal"), solo actualiza el nombre;
 * si no existía (primera selección), construye los 3 elementos e insertarlos.
 * @param {Object} store - {ID, name, address1, city, postalCode}
 * @returns {void}
 */
function updateStoreDisplay(store) {
    var $selector = $("[data-js-delivery-method-selector]");
    var $storeName = $selector.find(".delivery-method__store-name");

    if ($storeName.length) {
        // Ya existía — solo actualizar el nombre
        $storeName.text(store.name).attr("title", store.name);
        return;
    }

    // No existía — construir los 3 elementos sueltos e insertarlos en la card
    var storeIconUrl = $selector.data("store-icon-url");
    var changeStoreLabel = $selector.data("change-store-label");
    var productId = $selector.find("[data-js-store-radio]").attr("data-pid");

    var $icon = $(
        '<img class="delivery-method__store-icon" src="' +
            storeIconUrl +
            '" alt="" aria-hidden="true" />',
    );

    var $name = $(
        '<strong class="delivery-method__store-name" title="' +
            store.name +
            '">' +
            store.name +
            "</strong>",
    );

    var $changeButton = $(
        '<button type="button" class="delivery-method__change-store" data-pid="' +
            productId +
            '" data-js-change-store>' +
            changeStoreLabel +
            "</button>",
    );

    $selector
        .find('input[value="retiro-sucursal"]')
        .closest(".delivery-method__card")
        .append($icon, $name, $changeButton);
}

/**
 * Deshabilita el radio "Retirar por sucursal" Y el botón "Cambiar sucursal"
 * cuando la sucursal YA elegida no tiene stock del talle (además del mensaje
 * inline y del bloqueo de "Agregar al carrito"). Mientras está en falta, el
 * radio queda deshabilitado y desmarcado (un método no disponible nunca se ve
 * marcado) y no se puede abrir el selector de sucursales desde la PDP.
 * @param {jQuery} $selector - [data-js-delivery-method-selector]
 * @param {boolean} outOfStock - true si la sucursal elegida no tiene stock
 * @returns {void}
 */
function setStoreOutOfStock($selector, outOfStock) {
    var $storeRadio = $selector.find("[data-js-store-radio]");
    var $changeStore = $selector.find("[data-js-change-store]");
    var wasOutOfStock =
        $selector.attr("data-selected-store-out-of-stock") === "true";

    if (outOfStock) {
        $selector.attr("data-selected-store-out-of-stock", "true");
        $storeRadio.prop("disabled", true).prop("checked", false);
        $changeStore.prop("disabled", true);
        return;
    }

    if (!wasOutOfStock) {
        return;
    }

    $selector.attr("data-selected-store-out-of-stock", "false");

    var hasVariant = $selector.attr("data-has-variant") === "true";
    var storeAvailable = $selector.attr("data-store-available") !== "false";

    $storeRadio.prop("disabled", !hasVariant || !storeAvailable);
    $changeStore.prop("disabled", !hasVariant || !storeAvailable);
    checkSessionMethodIfAvailable($selector);
}

/**
 * La sucursal elegida se limpió porque el carrito quedó vacío (el servidor ya
 * la borró de la sesión): deja la PDP sin sucursal para que el cliente la
 * vuelva a elegir. NO toca el método de entrega: el servidor tampoco lo borra,
 * así que el radio de sucursal sigue marcado y "Agregar al carrito" queda
 * bloqueado hasta que se elija una sucursal.
 * @returns {void}
 */
function clearSelectedStoreUi() {
    var $selector = $("[data-js-delivery-method-selector]");

    if (!$selector.length) {
        return;
    }

    $selector.attr("data-selected-store-id", "");

    // Bloque de sucursal (ícono + nombre + "Cambiar sucursal"). Lo renderiza el
    // ISML solo si había sucursal; updateStoreDisplay lo vuelve a armar al elegir.
    $selector
        .find(
            ".delivery-method__store-icon, .delivery-method__store-name, .delivery-method__change-store",
        )
        .remove();

    // Selección pendiente de una apertura anterior del modal.
    selectedValue = null;
    isStoreConfirmed = false;

    // Inputs globales de tracking: sin sucursal, pero conservando el método.
    var canonicalEvents = require("../analytics/canonicalEvents");

    canonicalEvents.updateGlobalDeliveryState(
        $selector.attr("data-delivery-method") || null,
        null,
    );

    evaluateDeliveryGate(currentPid);
}

/**
 * Actualiza el estado visual del botón Agregar al carrito y su mensaje de
 * título (tooltip). NO gestiona el mensaje inline de disponibilidad de
 * sucursal ([data-js-store-stock-message]) en el caso "habilitado" — eso lo
 * hace evaluateDeliveryGate, para que el mensaje refleje la disponibilidad
 * real de la sucursal sin importar cuál sea el método de entrega activo.
 * @param {boolean} hasDeliveryMethod - si hay método completo en sesión
 * @param {boolean|null} hasStock - si el SKU activo tiene stock en la sucursal;
 *   null cuando todavía no hay variación (talle) seleccionada
 * @param {boolean} [isCcOnlyBlock] - true cuando el bloqueo es porque el
 *   producto solo admite retiro por sucursal y el método en sesión es otro
 * @returns {void}
 */
function updateAddToCartGate(hasDeliveryMethod, hasStock, isCcOnlyBlock) {
    var $inlineMessage = $("[data-js-store-stock-message]");
    var $selectStorePdpBtn = $("[data-js-pdp-add-to-cart-button]");
    $selectStorePdpBtn.toggleClass("d-none", false);
    var $addToCart = $("[data-js-add-to-cart]");

    if (!hasDeliveryMethod) {
        $addToCart
            .prop("disabled", true)
            .addClass("disabled")
            .attr(
                "title",
                isCcOnlyBlock
                    ? "Este producto solo está disponible para retiro por sucursal"
                    : "Seleccioná un método de entrega para continuar",
            );

        $inlineMessage.addClass("d-none").text("");

        return;
    }

    if (hasStock === null) {
        $addToCart
            .prop("disabled", true)
            .addClass("disabled")
            .attr("title", "Seleccioná un talle para continuar");

        $inlineMessage.addClass("d-none").text("");

        return;
    }

    if (!hasStock) {
        $addToCart
            .prop("disabled", true)
            .addClass("disabled")
            .removeAttr("title");

        $inlineMessage
            .text(
                "Este talle no está disponible en la sucursal seleccionada. Probá con otro talle u otra sucursal.",
            )
            .removeClass("d-none");

        return;
    }

    $addToCart
        .prop("disabled", false)
        .removeClass("disabled")
        .removeAttr("title");
}

/**
 * Evalúa el gate de add-to-cart según método de entrega, producto CC-only y
 * stock en la sucursal ya elegida. Es el punto central que decide el estado
 * del botón "Agregar al carrito", el mensaje inline de disponibilidad, y si
 * corresponde, deja el radio de sucursal listo para que el usuario cambie de
 * sucursal desde el mismo lugar.
 *
 * Se llama en 3 momentos: al cargar el PDP (init), tras cada
 * product:afterAttributeSelect (cambio de talle/atributo), y tras confirmar
 * sucursal o método de entrega (confirmSelection / click en envío a domicilio).
 *
 * @param {string} pid - SKU/variante activo
 * @returns {void}
 */
function evaluateDeliveryGate(pid) {
    var $selector = $("[data-js-delivery-method-selector]");

    var deliveryMethod = $selector.attr("data-delivery-method");
    var selectedStoreId = $selector.attr("data-selected-store-id");
    var hasVariant = $selector.attr("data-has-variant") === "true";

    var isStorePickup = deliveryMethod === "retiro-sucursal";
    var isCcOnly = $selector.attr("data-is-cc-only") === "true";
    var hasCompleteMethod =
        deliveryMethod && (!isStorePickup || !!selectedStoreId);

    var $inlineMessage = $("[data-js-store-stock-message]");

    /**
     * Decide el estado del botón, con el resultado de stock ya resuelto
     * (o null si no correspondía consultarlo). Misma prioridad que antes:
     * método incompleto > CC-only con método inválido > sin talle > stock
     * en sucursal (solo si retiro-sucursal es el método activo) > habilitado.
     * @param {boolean|null} hasStockInStore
     */
    function resolveGate(hasStockInStore) {
        if (!hasCompleteMethod) {
            updateAddToCartGate(false, false);
            return;
        }

        if (isCcOnly && !isStorePickup) {
            // El producto solo admite retiro por sucursal, pero el método
            // guardado en sesión es envío a domicilio/punto de retiro (pudo
            // haberse seteado con una variante distinta de este mismo
            // producto, o en otro producto durante la misma sesión). No es
            // un método válido para esta variante — se trata como incompleto.
            updateAddToCartGate(false, false, true);
            return;
        }

        if (!hasVariant || !pid) {
            // Sin variación (talle) seleccionada: no hay SKU real todavía,
            // sin importar el método de entrega elegido.
            updateAddToCartGate(true, null);
            return;
        }

        if (isStorePickup) {
            updateAddToCartGate(true, !!hasStockInStore);
            return;
        }

        updateAddToCartGate(true, true);
    }

    // El mensaje de disponibilidad de sucursal es informativo y se evalúa
    // SIEMPRE que haya variante + sucursal asociada — sin importar si ya hay
    // un método de entrega completo elegido, ni si el producto es CC-only.
    // Bug real encontrado en desarrollo: antes este chequeo vivía adentro
    // de los "if" de método completo / CC-only, así que si el usuario
    // todavía no había elegido ningún método (deliveryMethod vacío) pero ya
    // tenía una sucursal asociada (ej. desde el filtro de PLP), el mensaje
    // nunca se evaluaba — la función cortaba antes de llegar a chequear
    // stock. El radio "Retirar por sucursal" sigue siendo una opción válida
    // aunque la sucursal ya elegida no tenga stock — el usuario puede
    // cambiar de sucursal desde el mismo radio ("Cambiar sucursal").
    if (hasVariant && pid && selectedStoreId) {
        var checkUrl = $selector.attr("data-check-stock-url");

        $.ajax({
            url: checkUrl,
            type: "GET",
            dataType: "json",
            data: { pid: pid, storeId: selectedStoreId },
            success: function (response) {
                var hasStockInStore = !!response.hasStock;

                setStoreOutOfStock($selector, !hasStockInStore);

                if (!hasStockInStore) {
                    $inlineMessage
                        .text(
                            "Este talle no está disponible en la sucursal seleccionada. Probá con otro talle u otra sucursal.",
                        )
                        .removeClass("d-none");
                } else {
                    $inlineMessage.addClass("d-none").text("");
                }

                resolveGate(hasStockInStore);
            },
            error: function () {
                $inlineMessage
                    .text(
                        "Este talle no está disponible en la sucursal seleccionada. Probá con otro talle u otra sucursal.",
                    )
                    .removeClass("d-none");

                setStoreOutOfStock($selector, true);

                resolveGate(false);
            },
        });

        return;
    }

    $inlineMessage.addClass("d-none").text("");
    setStoreOutOfStock($selector, false);
    resolveGate(null);
}

/**
 * Muestra/oculta el spinner de carga del modal de sucursales. Mientras carga
 * (show=true), oculta tanto los resultados como el empty state — al terminar
 * (show=false, disparado desde el "complete" del AJAX), no toca ninguno de
 * los dos: esa decisión ya la tomó toggleEmpty() en el success/error
 * correspondiente, y no hay que pisarla acá.
 * @param {boolean} show - true para mostrar el spinner, false para ocultarlo
 * @returns {void}
 */
function toggleLoading(show) {
    $("[data-js-loading]").toggleClass("d-none", !show);

    if (show) {
        // Mientras carga: ocultar ambos, resultados Y empty state
        $("[data-js-results]").addClass("d-none");
        $("[data-js-empty]").addClass("d-none");
    }

    // Cuando show=false (en el "complete"): NO tocar resultados ni empty —
    // esa decisión ya la tomó toggleEmpty en el success/error, no hay que pisarla
}

/**
 * Muestra/oculta el estado "sin resultados" del modal de sucursales, y
 * oculta/muestra el contenedor de resultados en espejo (nunca se ven los dos
 * al mismo tiempo).
 * @param {boolean} show - true para mostrar el empty state
 * @param {string} [message] - texto del empty state; si se omite, deja el
 *   texto que ya estuviera puesto
 * @returns {void}
 */
function toggleEmpty(show, message) {
    var $empty = $("[data-js-empty]");
    var $results = $("[data-js-results]");

    if (message) {
        $empty.find("[data-js-empty-message]").text(message);
    }

    $empty.toggleClass("d-none", !show);
    $results.toggleClass("d-none", show); // ← agregado: oculta resultados cuando se muestra el empty state
}

/**
 * Anuncia la cantidad de resultados del último search en una región de
 * status dedicada ([data-js-results-status], sr-only + aria-live="polite").
 * Se usa una región separada del contenedor de resultados a propósito: ese
 * contenedor tiene contenido interactivo (los radios de sucursal) y si le
 * pusiéramos aria-live directo, el lector de pantalla intentaría anunciar
 * cada sucursal nueva del listado en cada búsqueda, generando ruido.
 * @param {number} count - cantidad de sucursales encontradas
 * @returns {void}
 */
function announceResults(count) {
    var message =
        count > 0
            ? count + " sucursales encontradas"
            : "No se encontraron sucursales";

    $("[data-js-results-status]").text(message);
}

/**
 * Busca sucursales en backend (Stores-GetAvailableStores) y renderiza el
 * resultado (HTML ya armado por el servidor) dentro de [data-js-results].
 * Si el render trae una sucursal pre-marcada (reapertura del modal
 * con "Cambiar sucursal"), habilita el botón Confirmar de una vez.
 * @param {string} pid - id del producto/variante
 * @param {string} searchTerm - término de búsqueda
 * @returns {void}
 */
function searchStores(pid, searchTerm) {
    var url = $("#deliverySelectorModal").data("url");

    if (!url || !pid) {
        toggleLoading(false);
        toggleEmpty(
            true,
            "Seleccioná un talle para ver sucursales disponibles.",
        );
        return;
    }

    toggleLoading(true);
    toggleEmpty(false);

    $.ajax({
        url: url,
        type: "GET",
        dataType: "html",
        data: {
            pid: pid,
            searchTerm: searchTerm || "",
        },
        success: function (html) {
            $("[data-js-results]").empty().html(html);

            var count = $("[data-js-results] .delivery-selector-item").length;

            toggleEmpty(
                count === 0,
                "No se encontraron sucursales con ese criterio.",
            );
            announceResults(count);

            // Si el render ya trae una sucursal pre-marcada, habilitar Confirmar
            var $checkedRadio = $(
                "[data-js-results] .delivery-selector-item__radio:checked",
            );

            if ($checkedRadio.length) {
                selectedValue = $checkedRadio.val();
                $("[data-js-confirm]").prop("disabled", false);
            } else {
                selectedValue = null;
                $("[data-js-confirm]").prop("disabled", true);
            }

            updateResetButtonState();
        },
        error: function (jqXHR) {
            $("[data-js-results]").empty();

            var status = jqXHR.status;
            var message;

            if (status === 400 || status === 404) {
                message =
                    "No pudimos cargar las sucursales para este producto. Probá recargar la página.";
            } else {
                message =
                    "Ocurrió un error al buscar sucursales. Intentá nuevamente.";
            }

            toggleEmpty(true, message);
            announceResults(0);
        },
        complete: function () {
            toggleLoading(false);
        },
    });
}

/**
 * Limpia el buscador y la selección pendiente del modal, y vuelve a pedir el
 * listado completo de sucursales (sin término de búsqueda). Disparado por el
 * botón "Restablecer".
 * @returns {void}
 */
function resetSelection() {
    $("#deliverySelectorSearch").val("");

    $("[data-js-confirm]").prop("disabled", true);

    toggleEmpty(false);

    selectedValue = null;

    updateResetButtonState();

    searchStores(currentPid, "");
}

/**
 * Abre el modal de búsqueda de sucursales para el producto/variante activo,
 * reseteando cualquier selección pendiente de una apertura anterior, y
 * dispara la búsqueda inicial (sin término).
 * @param {string} pid - id del producto/variante activo
 * @param {jQuery} [$trigger] - elemento que disparó la apertura, para
 *   restaurar el foco ahí como fallback si no existe el radio de sucursal
 * @returns {void}
 */
function openModal(pid, $trigger) {
    currentPid = pid;
    $lastFocusedTrigger = $trigger || null;
    selectedValue = null; // No arrastrar selección pendiente de una apertura anterior
    isStoreConfirmed = false; // se marca true solo si confirmSelection() tiene éxito

    $("#deliverySelectorSearch").val(""); // ← agregado: limpiar el input al abrir

    updateResetButtonState();

    $("#deliverySelectorModal").modal("show");

    searchStores(currentPid, "");
}

/**
 * Cierra el modal de búsqueda de sucursales (Bootstrap modal("hide")). No
 * persiste ni descarta nada por sí sola — la reversión del radio si se
 * cierra sin confirmar vive en el handler "hidden.bs.modal" de init().
 * @returns {void}
 */
function closeModal() {
    $("#deliverySelectorModal").modal("hide");
}

/**
 * Registra la sucursal tildada en el modal (todavía sin confirmar) y
 * habilita el botón Confirmar. Disparado por el "change" de los radios de
 * sucursal dentro del listado.
 * @param {HTMLInputElement} radio - el input[type=radio] tildado
 * @returns {void}
 */
function selectOption(radio) {
    selectedValue = radio.value;

    $("[data-js-confirm]").prop("disabled", false);

    updateResetButtonState();
}

/**
 * Confirma la sucursal tildada en el modal (Stores-SelectStore, POST). Tres
 * resultados posibles:
 *  - mixedOrigin: el carrito ya tiene otro origen — se cierra el modal y se
 *    muestra el modal de aviso, sin persistir nada.
 *  - !success: error genérico (ej. producto/sucursal inválidos) — se avisa
 *    vía el evento delivery-selector:error, el modal queda abierto.
 *  - éxito: se cierra el modal, se marca isStoreConfirmed, se actualiza el
 *    DOM (atributos data-* + bloque de sucursal seleccionada), se dispara
 *    el tracking canónico y se reevalúa el gate de add-to-cart.
 * @returns {void}
 */
function confirmSelection() {
    if (!selectedValue) {
        return;
    }

    var url = $('input[name="data-select-store"]').val();

    var $selectorForEvents = $("[data-js-delivery-method-selector]");
    var previousDeliveryMethod = $selectorForEvents.attr("data-delivery-method") || null;

    $.ajax({
        url: url,
        type: "POST",
        dataType: "json",
        data: {
            pid: currentPid,
            storeId: selectedValue,
        },
        success: function (response) {
            if (response.mixedOrigin) {
                closeModal();
                // Se pasa la petición que disparó el conflicto —
                // permite retomar la sucursal nueva después de vaciar,
                // en vez de que el usuario tenga que elegirla de cero.
                storeSelectorModal.showMixedOriginModal(
                    response.message,
                    response.title,
                    true,
                    { url: url, data: { pid: currentPid, storeId: selectedValue } },
                    response.titleBtn
                );
                return;
            }

            if (!response.success) {
                $("body").trigger("delivery-selector:error", [response]);
                return;
            }

            closeModal();

            isStoreConfirmed = true;

            var $selector = $("[data-js-delivery-method-selector]");

            $selector
                .attr("data-delivery-method", "retiro-sucursal")
                .attr("data-selected-store-id", response.store.ID);

            $selector
                .find('input[name="deliveryMethod"][value="retiro-sucursal"]')
                .prop("checked", true);

            updateStoreDisplay(response.store);

            $("body").trigger("delivery-selector:store-selected", [
                response.store,
            ]);

            // Store_selected — surface pdp, source
            // retiro_sucursal_modal, tal cual el ejemplo de la story.
            var canonicalEvents = require("../analytics/canonicalEvents");

            var previousStoreId =
                    $('[name="selectedStoreId"]').val() || null;

                var previousSelectedStore = previousStoreId
                    ? canonicalEvents.toStorePayload({
                          ID: previousStoreId,
                          name: $('[name="selectedStoreName"]').val() || null,
                          city: $('[name="selectedStoreCity"]').val() || null,
                          province: $('[name="selectedStoreState"]').val() || null,
                      })
                    : null;
 
            canonicalEvents.pushCanonicalEvent("store_selected", {
                surface: "pdp",
                source: "retiro_sucursal_modal",
                selected_store: canonicalEvents.toStorePayload(response.store),
                delivery_method: "retiro-sucursal",
                previous_selected_store: previousSelectedStore
            });
 
            canonicalEvents.pushCanonicalEvent("delivery_method_selected", {
                surface: "pdp",
                source: "pdp",
                selected_store: canonicalEvents.toStorePayload(response.store),
                delivery_method: "retiro-sucursal",
                previous_delivery_method: previousDeliveryMethod,
                postal_code: null,
                delivery_option_id: null,
            });

            canonicalEvents.updateGlobalDeliveryState("retiro-sucursal", response.store);

            evaluateDeliveryGate(currentPid);
        },
        error: function () {
            $("body").trigger("delivery-selector:error");
        },
    });
}

/**
 * Punto de entrada del módulo. Si enableStoreSelector está apagado, no
 * registra ningún listener (el feature queda 100% inerte, el botón nativo de
 * SFRA no se ve afectado). Si está prendido:
 *  - Evalúa el gate una vez al cargar el PDP.
 *  - Engancha el modal de mixed-origin (storeSelectorModal).
 *  - Registra todos los handlers del 3-radio y del modal de sucursales.
 * @returns {void}
 */
function init() {
    const enableStoreSelector = $('[name="enableStoreSelector"]').val() === "true";

    // If the Store Selector is enabled, do not initialize the postal code modal
    if (!enableStoreSelector) {
        return;
    }

    // El ISML renderiza "checked" según la sesión sin saber la disponibilidad
    // real; un método no disponible (radio deshabilitado) no debe verse marcado.
    checkSessionMethodIfAvailable($("[data-js-delivery-method-selector]"));

    currentPid = $("#productSKU").text().trim();
    evaluateDeliveryGate(currentPid);

    storeSelectorModal.bindMixedOriginModal();

    $("body")
        // Cambio de talle/atributo del producto (evento nativo de SFRA).
        // Sincroniza data-has-variant / data-is-cc-only en el DOM, habilita
        // o deshabilita los radios y el botón "Cambiar sucursal" según
        // corresponda, y muestra/oculta el mensaje de producto CC-only.
        .on("product:afterAttributeSelect", function (e, response) {
            var $selector = $("[data-js-delivery-method-selector]");
            // var $messageattribute = $("[data-js-pretalle-msg]");

            if (!$selector.length) {
                return;
            }

            var responseData = response && response.data ? response.data : null;
            var productData = responseData ? responseData.product : null;
            var isCcOnlyProduct = !!(
                responseData && responseData.isCcOnlyProduct
            );

            var hasVariant =
                !!productData && productData.productType === "variant";

            // Mantener sincronizado el atributo en el DOM: evaluateDeliveryGate
            // lo lee en cada llamada, no solo en el load inicial.
            $selector.attr("data-has-variant", hasVariant);
            $selector.attr("data-is-cc-only", isCcOnlyProduct);

            // Disponibilidad de cada método de entrega para la variante
            // elegida. Contrato con el servidor:
            //   responseData.availableDeliveryMethods = {
            //       storePickup, homeDelivery, pickupPoint }  (booleanos)
            // Si la propiedad o alguna clave no viene, se asume disponible:
            // el comportamiento no cambia hasta que el servidor la mande.
            var methods =
                (responseData && responseData.availableDeliveryMethods) || {};
            var storeAvailable = methods.storePickup !== false;
            var homeAvailable = methods.homeDelivery !== false;
            var pickupAvailable = methods.pickupPoint !== false;

            // Se guarda la disponibilidad del método para este talle y se reinicia el
            // "sin stock en la sucursal elegida": lo vuelve a decidir el chequeo de
            // stock que corre al final de este handler (evaluateDeliveryGate).
            $selector
                .attr("data-store-available", storeAvailable)
                .attr("data-selected-store-out-of-stock", "false");

            // El componente NO se oculta sin talle — se muestra el
            // mensaje "Seleccioná talle..." con los radios visibles (disabled).
            // $messageattribute.toggleClass("d-none", hasVariant);

            // Producto solo disponible para retiro por sucursal: no se puede
            // enviar a domicilio ni a un punto de retiro. Se muestra el
            // mensaje y se deshabilita "Envío a domicilio" (el único de los
            // dos que hoy es togglable — "Envío a punto de retiro" ya queda
            // siempre disabled por estar fuera de alcance).
            $selector
                .find("[data-js-cconly-msg]")
                .toggleClass("d-none", !(hasVariant && isCcOnlyProduct));

            // Solo la radio de retiro-sucursal se habilita/deshabilita según
            // hasVariant. La de envío a domicilio depende además de que el
            // producto no sea CC-only.
            var $storeRadio = $selector.find("[data-js-store-radio]");

            $storeRadio.prop("disabled", !hasVariant || !storeAvailable);

            // Talle sin retiro por sucursal: si el radio había quedado
            // marcado, se destilda (mismo criterio que domicilio / punto).
            if (!storeAvailable && $storeRadio.prop("checked")) {
                $storeRadio.prop("checked", false);
            }

            var $homeDeliveryRadio = $selector.find(
                "[data-js-home-delivery-radio]",
            );

            $homeDeliveryRadio.prop(
                "disabled",
                !hasVariant || isCcOnlyProduct || !homeAvailable,
            );

            // Si quedó marcada (de una variante anterior compatible) pero la
            // nueva variante es CC-only, hay que destildarla — un radio
            // disabled puede seguir "checked" visualmente si no se lo saca
            // a mano.
            if (
                (isCcOnlyProduct || !homeAvailable) &&
                $homeDeliveryRadio.prop("checked")
            ) {
                $homeDeliveryRadio.prop("checked", false);
            }

            // Envío a un punto de retiro radio.
            var $pickupPointRadio = $selector.find(
                "[data-js-pickup-point-radio]",
            );

            $pickupPointRadio.prop(
                "disabled",
                !hasVariant || isCcOnlyProduct || !pickupAvailable,
            );

            if (
                (isCcOnlyProduct || !pickupAvailable) &&
                $pickupPointRadio.prop("checked")
            ) {
                $pickupPointRadio.prop("checked", false);
            }

            // El radio marcado refleja el método vigente en sesión solo si ese
            // radio quedó habilitado arriba (talle elegido, no CC-only y
            // disponible). Si el método no está disponible, no se marca; al
            // pasar a una talla que sí lo admite, se vuelve a marcar.
            checkSessionMethodIfAvailable($selector);

            // Deshabilitar también el botón "Cambiar sucursal"
            $selector
                .find("[data-js-change-store]")
                .prop("disabled", !hasVariant || !storeAvailable);

            // El estado visual "disabled" de store-icon/store-name/change-store
            // ya lo resuelve el CSS solo, vía :has(.delivery-method__radio:disabled)
            // sobre .delivery-method__card — no hace falta togglear ninguna clase acá.

            currentPid = hasVariant ? productData.id : null;

            $("#btn-add-to-cart").prop("disabled", true);

            evaluateDeliveryGate(currentPid);
        })
        // Enter en cualquiera de los 3 radios dispara el mismo flujo que un
        // click real — Space ya funciona nativo del navegador, sin JS extra.
        .on("keydown", ".delivery-method__radio", function (e) {
            if (e.key === "Enter") {
                e.preventDefault();

                $(this)
                    .prop("checked", true)
                    .trigger("click")
                    .trigger("change");
            }
        })

        // Click en "Cambiar sucursal" o en el radio "Retirar por sucursal":
        // ambos abren el modal de búsqueda, nunca escriben nada en sesión
        // por sí solos (eso pasa recién al Confirmar).
        .on(
            "click",
            "[data-js-change-store], [data-js-store-radio]",
            function () {
                var pid = $("#productSKU").text().trim();

                if (!pid) {
                    return;
                }

                openModal(pid, $(this));
            },
        )

        // "Envío a domicilio" y "Envío a un punto de retiro" comparten el mismo comportamiento — ninguno abre modal en PDP, los dos solo setean el método en sesión y actualizan el DOM.
        .on(
            "click",
            "[data-js-home-delivery-radio], [data-js-pickup-point-radio]",
            function () {
                var $radio = $(this);
                var method = $radio.val();
                var $selector = $("[data-js-delivery-method-selector]");
                var url = $selector.data("set-delivery-method-url");

                $.ajax({
                    url: url,
                    type: "POST",
                    dataType: "json",
                    data: { deliveryMethod: method },
                    success: function (response) {
                        if (response.mixedOrigin) {
                            // El carrito ya tiene productos de otro origen: no se
                            // guardó nada. Se vuelve al método vigente (el click
                            // nativo ya había marcado este radio) y se avisa. Si el
                            // usuario vacía el carrito, se reintenta este mismo POST.
                            checkSessionMethodIfAvailable($selector);

                            storeSelectorModal.showMixedOriginModal(
                                response.message,
                                response.title,
                                true,
                                { url: url, data: { deliveryMethod: method } },
                                response.titleBtn
                            );
                            return;
                        }

                        if (!response.success) {
                            $radio.prop("checked", false);
                            $("body").trigger("delivery-selector:error", [
                                response,
                            ]);
                            return;
                        }

                        $selector.attr("data-delivery-method", method);


                        $("body").trigger(
                            "delivery-selector:delivery-method-selected",
                            [method],
                        );

                        evaluateDeliveryGate(currentPid);
                    },
                    error: function () {
                        $radio.prop("checked", false);
                        $("body").trigger("delivery-selector:error");
                    },
                });
            },
        )

        // Búsqueda del modal, con debounce de 300ms.
        .on("input", "#deliverySelectorSearch", function () {
            clearTimeout(searchTimeout);

            var value = $(this).val();

            updateResetButtonState();

            searchTimeout = setTimeout(function () {
                searchStores(currentPid, value);
            }, 300);
        })

        // Focus trap manual del modal (Escape cierra sin persistir; Tab /
        // Shift+Tab quedan atrapados entre el primer y último elemento
        // focuseable, excluyendo explícitamente los disabled y los
        // tabindex="-1" como el botón decorativo de la lupa de búsqueda).
        .on("keydown", "#deliverySelectorModal", function (e) {
            if (e.key === "Escape" || e.keyCode === 27) {
                closeModal();
                return;
            }

            if (e.key !== "Tab") {
                return;
            }

            var $focusable = $(this)
                .find(
                    'input:not([disabled]):not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])',
                )
                .filter(":visible");

            if (!$focusable.length) {
                return;
            }

            var $first = $focusable.first();
            var $last = $focusable.last();

            if (e.shiftKey && document.activeElement === $first[0]) {
                e.preventDefault();
                $last.trigger("focus");
            } else if (!e.shiftKey && document.activeElement === $last[0]) {
                e.preventDefault();
                $first.trigger("focus");
            }
        })

        // Tildar una sucursal en el listado del modal.
        .on("change", ".delivery-selector-item__radio", function () {
            selectOption(this);
        })

        .on("click", "[data-js-reset]", function () {
            resetSelection();
        })

        .on("click", "[data-js-confirm]", function () {
            confirmSelection();
        })

        // El carrito quedó vacío y el servidor limpió la sucursal elegida (evento
        // que dispara el handler de borrado, p.ej. desde el minicart): la PDP deja
        // de mostrarla y el cliente tiene que volver a elegir.
        .on("cart:store-cleared", function () {
            clearSelectedStoreUi();
        })

        // Escucha la respuesta del add-to-cart nativo de SFRA. Si el server
        // devolvió showModal (mixed-origin, stock insuficiente, etc.), muestra
        // el modal de aviso y limpia el popover del minicart que SFRA ya
        // habría abierto.
        .on("click", ".add-to-cart", function () {
            $("body").one("product:afterAddToCart", function (event, response) {
                if (response && response.showModal) {
                    storeSelectorModal.showMixedOriginModal(
                        response.message,
                        response.title,
                        !!response.mixedOrigin,
                        null,
                        response.titleBtn
                    );
                    $(".minicart .popover").empty();
                    $(".minicart .popover").removeClass("show");
                }
            });
        });

    $("#deliverySelectorModal")
        // Foco inicial del modal: el input de búsqueda, sin importar el
        // orden real del DOM (que tiene el botón de cerrar antes).
        .on("shown.bs.modal", function () {
            $("#deliverySelectorSearch").trigger("focus");
        })
        .on("hidden.bs.modal", function () {
            var $selector = $("[data-js-delivery-method-selector]");

            // Si se cerró sin confirmar (X, Escape, click afuera, o mixed-origin
            // rechazado), el radio "Retirar por sucursal" quedó marcado por
            // el click nativo del navegador aunque nunca se confirmó ninguna
            // sucursal. Hay que revertirlo al método que sigue vigente en
            // sesión (data-delivery-method no cambia hasta que confirmSelection
            // tiene éxito), si no el botón de add-to-cart queda evaluado con
            // un estado visual que no es el real.
            if (!isStoreConfirmed) {
                checkSessionMethodIfAvailable($selector);

                evaluateDeliveryGate(currentPid);
            }

            // El foco vuelve SIEMPRE al radio "Retirar por sucursal", no al trigger genérico
            var $storeRadio = $(
                '[data-js-delivery-method-selector] input[value="retiro-sucursal"]',
            );

            if ($storeRadio.length && !$storeRadio.prop("disabled")) {
                $storeRadio.trigger("focus");
            } else if (
                $lastFocusedTrigger &&
                $lastFocusedTrigger.closest("body").length &&
                !$lastFocusedTrigger.prop("disabled")
            ) {
                $lastFocusedTrigger.trigger("focus");
            } else {
                $selector.attr("tabindex", "-1").trigger("focus");
            }
        });
}

module.exports = {
    init: init,
    openModal: openModal,
    closeModal: closeModal,
    resetSelection: resetSelection,
    searchStores: searchStores,
};